import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { Navigation, Autoplay, EffectFade } from "swiper/modules"

export default class extends Controller {
  static values = {
    interval: { type: Number, default: 5000 },
    groups: { type: Array, default: [] }
  }

  connect() {
    this.buildCustomPagination()

    this.swiper = new Swiper(this.element, {
      modules: [Navigation, Autoplay, EffectFade],
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      autoplay: {
        delay: this.intervalValue,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      on: {
        afterInit: (swiper) => this.updateActiveGroup(swiper),
        slideChange: (swiper) => this.updateActiveGroup(swiper)
      }
    })
  }

  buildCustomPagination() {
    const container = this.element.querySelector(".swiper-pagination-custom")
    if (!container || !this.groupsValue.length) return

    this.groupsValue.forEach((group, index) => {
      const bullet = document.createElement("span")
      bullet.className = "custom-bullet"
      bullet.dataset.groupIndex = index
      bullet.dataset.firstSlide = group.firstSlide
      bullet.dataset.color = group.color
      bullet.addEventListener("click", () => this.goToGroup(index))
      container.appendChild(bullet)
    })
  }

  goToGroup(groupIndex) {
    const group = this.groupsValue[groupIndex]
    if (group) {
      this.swiper.slideToLoop(group.firstSlide)
    }
  }

  updateActiveGroup(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex]
    if (!activeSlide) return

    const activeGroup = parseInt(activeSlide.dataset.slideGroup, 10)
    const bullets = this.element.querySelectorAll(".swiper-pagination-custom .custom-bullet")

    bullets.forEach((bullet, index) => {
      bullet.classList.remove("active")
      bullet.style.backgroundColor = ""

      if (index === activeGroup) {
        bullet.classList.add("active")
        bullet.style.backgroundColor = bullet.dataset.color
      }
    })
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy()
    }
  }
}
